module.exports = __webpack_public_path__ + "files/6e02397f334fba755a6ae4942c3d18b4.png";